import PropTypes from "prop-types";
import React from "react";

import styled from "styled-components/macro";
import { colors } from "theme/constants";

import FnrButtonWrapper from "UI/FnrButtonWrapper";
import FnrContainedIcon from "UI/FnrContainedIcon";

import useIsMobile from "Utilities/Hooks/useIsMobile";

SidebarLinkButton.propTypes = {
  isActive: PropTypes.bool,
  icon: PropTypes.string,
  onClick: PropTypes.func,
  loading: PropTypes.bool,
  text: PropTypes.node,
};

export default function SidebarLinkButton({
  icon,
  onClick,
  loading,
  isActive,
  text,
  ...rest
}) {
  const isMobile = useIsMobile(680);

  return (
    <Wrapper $active={isActive} onClick={onClick} {...rest}>
      <Inside
        $isMobileActive={isMobile && isActive}
        className={`sidebar-link-button-${text.split(" ").join("-")}`}
      >
        <FnrContainedIcon
          size={"md"}
          isLoading={loading}
          icon={icon}
          color={"rgb(24, 41, 65)"}
        />
        <MenuTitle>{text}</MenuTitle>
      </Inside>
    </Wrapper>
  );
}

const Wrapper = styled(FnrButtonWrapper)`
  font-size: 20px;
  margin: 0 -8px;
  white-space: nowrap;
  border-radius: 14px;
  transition: background 0.8s;
  box-shadow: ${({ $active }) =>
    $active ? "rgba(0, 0, 0, 0.08) 1px 0px 3px" : "transparent 1px 1px 3px"};
  cursor: ${({ $active }) => ($active ? "default" : "pointer")};
  background: ${({ $active }) => ($active ? "#fff" : "transparent")};
  border: ${({ $active }) =>
    $active ? "1px solid #e5e5e5" : "1px solid transparent"};
  transition: all 0.2s;

  &:hover,
  &:focus {
    background: ${({ $active }) => ($active ? "#fff" : "#c7e2f2")};
    transition: ${({ $active }) => ($active ? "#fff" : "#c7e2f2")};
  }

  @media screen and (max-width: 680px) {
    font-size: 18px;
    border-radius: 14px;
    padding: 4px 8px;
  }
  @media screen and (max-width: 440px) {
    font-size: 16px;
    border-radius: 10px;
    padding: 0;
  }
`;

const Inside = styled.div`
  padding: 10px;
  display: flex;
  align-items: center;
  gap: 10px;
  position: relative;
  min-height: 48px;
  color: inherit;
  /* color: ${({ $isMobileActive }) =>
    $isMobileActive ? colors.fnBlue : "inherit"}; */
  transition: scale 0.3s;

  &:active {
    scale: 0.95;
  }

  @media screen and (max-width: 680px) {
    padding: 3.5px 0px;
    gap: 4px;
  }
  @media screen and (max-width: 440px) {
    padding: 3px 6px 3px 3px;
    gap: 4px;
  }
`;

const Icon = styled.div`
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;

  @media screen and (max-width: 680px) {
    width: 28px;
    height: unset;
  }
`;
const MenuTitle = styled.div`
  font-family: Raleway, sans-serif;
  font-weight: 400;
`;